import { ExclamationCircleFilled } from '@ant-design/icons'
import Api from '@api/setMealManage'
import { JIA_MENG_GOODS_MANAGE_PATH_A } from '@constant'
import {
  getLocationQuery,
  getMerchantInfo,
  isArray,
  isObj,
  isStoreAccount,
  isString,
  jsonToHump,
  jsonToUnderline
} from '@util'
import { message, Modal } from 'hljd'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import { computed, observable, runInAction, toJS } from 'mobx'
import React from 'react'
import { CheckImg } from './CheckImgColorMode'
import CheckInputStore from './CheckInput/store'
import StepOneStore from './StepOne/store'
import StepThreeStore from './StepThree/store'
import StepTwoStore from './StepTwo/store'
import successModal from './successModal'

export default class {
  @observable max_step = undefined
  @observable weddingPhotoType = '1' // 婚纱摄影 propertyId 6 子分类

  constructor(id) {
    this.id = getLocationQuery('id') || id
    this.isEdit = !!this.id

    this.oldFormatData = {} // 编辑时的老数据，用于提交或跳转时比较是否改变
    this.merchant_info = getMerchantInfo()
    this.property_id = isStoreAccount() // 商家类别id
      ? getLocationQuery('propertyId')
      : this.merchant_info.property_id
    this.gender = getLocationQuery('gender') // 性别
    this.isSingle = getLocationQuery('isSingle') // 是否是发布单品(婚纱礼服特有)

    // 这里必须在 this.property_id this.gender this.isSingle 有值以后初始化 this.max_step
    this.max_step = this.getMaxStep()
    this.isDraft = getLocationQuery('type') === 'draft' // 是否编辑草稿页面
    this.checkImg = new CheckImg()
    this.stepOneStore = new StepOneStore(this)
    this.stepTwoStore = new StepTwoStore(this)
    this.stepThreeStore = new StepThreeStore(this)
    this.stepTwoStore.initAnchor()
  }

  // id （编辑状态才有）
  @observable id = null
  // 标签列表
  @observable tag_list = []
  // 详情数据（编辑时接口返回的源数据）
  @observable detailData = {}
  @observable spinning = false //是否为发布中
  @observable second_category_id // 子分类id
  // 由于初始定格式时没有考虑子分类的通用性，导致下面的子分类有单独的id
  @observable jewelryType = '1' // 婚戒首饰子分类   // 修改这两种子分类时，会对页面内其他地方造成影响，比如第二步中的服务内容、是否有第三步
  @observable scenicSpot = [] // 取景地选取列表

  init = async () => {
    if (this.isEdit) {
      // 编辑时获取详情
      await this.getDetail()
    }
    // await this.getTags()
    await this.getTagsAndExtra()

    // 保存原始数据，提交前比较是否修改
    this.oldFormatData = this.getFormatValues()
  }

  // 获取Tags并根据Tags返回执行业务处理
  getTagsAndExtra = async () => {
    await this.getTags()
    // 页面为编辑状态根据详情返回值和Tags返回值做逻辑处理
    if (this.isEdit) {
      this.settingScenicSpotByDestination()
    }
  }

  // 通过目的地设置取景地
  settingScenicSpotByDestination = async () => {
    const detail = this.detailData
    if (detail.second_category_id == 4) {
      const markList = this.stepOneStore.initTags(detail.tags, this.tag_list)
      let markId = this.stepOneStore.handleSearchMarkId(markList)
      await this.stepOneStore.queryScenicSpotList(markId)
    }
    // 详情接口取景地cover_path赋值到scenicSpotList
    const { scenicSpotImg = [] } = this.stepOneStore.form_values
    // 为了保证scenicSpotList能够存储到详情接口返回的数据，在此将详情接口返回的图片路径赋值到scenicSpotList里
    const list = this.stepOneStore.scenicSpotList.map(el => {
      const index = scenicSpotImg.findIndex(f => f.id === el.id)
      if (index !== -1) {
        el['cover_path'] = scenicSpotImg[index]['cover_path']
        return el
      }
      return toJS(el)
    })
    this.stepOneStore.setScenicSpot(
      this.stepOneStore.handleDeletedScenicSpotList(list, scenicSpotImg)
    )
  }

  /** 某些商家有子分类，修改时有额外操作 */
  @computed
  get onSecondCategoryChange() {
    let handler
    switch (String(this.property_id)) {
      case '6':
        // 婚纱摄影
        handler = this.onWeddingPhotoTypeChange
        break

      case '12':
        // 婚纱礼服
        handler = this.onWeddingDressTypeChange
        break

      case '14':
        // 婚戒
        handler = this.onJewelryTypeChange
        break

      default:
        handler = () => {
          this.stepTwoStore.sessionServiceStore.init()
        }
        break
    }
    return second_category_id => {
      this.second_category_id = second_category_id
      this.stepTwoStore.stepTwoData.merchandise_params_sort = undefined // 将排序状态充值
      handler(second_category_id)
    }
  }

  onScenicSpotChange = value => {
    this.scenicSpot = value
    this.stepTwoStore.sessionServiceStore.init()
  }

  /**  修改婚纱摄影子分类*/
  onWeddingPhotoTypeChange = value => {
    this.weddingPhotoType = value
    this.stepTwoStore.sessionServiceStore.init()
    this.getTags()
    this.max_step = this.getMaxStep()
  }

  onWeddingDressTypeChange = () => {
    this.stepTwoStore.sessionServiceStore.init()
    this.getTags()
  }

  /** 改变婚戒子分类 */
  onJewelryTypeChange = value => {
    this.jewelryType = value
    this.stepTwoStore.sessionServiceStore.init()
  }

  /**
   * 获取可配置模块数量
   * 部分类型没有套餐推荐信息模块
   */
  getMaxStep = () => {
    if (
      this.property_id == 6 &&
      (this.weddingPhotoType == 5 || this.weddingPhotoType == 2)
    ) {
      // 婚纱摄影子类型为 儿童摄影或结婚登记照
      return 2
    }

    if (this.property_id == 14 || this.property_id == 15) {
      // 婚戒首饰 || 花艺甜品
      return 2
    }

    if (this.property_id == 12 && this.isSingle == 1 && this.gender == 1) {
      // 婚纱礼服 && 单品管理 && 性别为男士
      return 2
    }

    return 3
  }

  //修改标签勾选
  setTagValues = list => {
    this.tag_list = cloneDeep(list)
  }

  /** 获取详情 */
  getDetail = async () => {
    const id = this.id
    const isSingle = getLocationQuery('isSingle')
    let api = Api.getDetail
    if (this.isDraft) {
      // 获取草稿详情
      if (this.isSingle) {
        api = Api.getSingleDraftDetail
      } else {
        api = Api.getPackageDraftDetail
      }
    }
    let { success, data } = await api({
      id,
      isSingle
    })
    if (success) {
      runInAction(async () => {
        if (this.isDraft) {
          data = data.content
        }
        jsonToUnderline(data)
        data.merchandise_items = data.merchandise_items || []
        // 把所有的number类型的值转为string
        data = Object.entries(data).reduce((acc, [key, value]) => {
          if (Object.prototype.toString.call(value) === '[object Number]') {
            value = String(value || '')
          }
          if (
            Object.prototype.toString.call(value) === '[object String]' &&
            value === '0'
          ) {
            value = ''
          }
          acc[key] = value
          return acc
        }, {})

        this.detailData = data

        this.second_category_id = data.second_category_id
        this.weddingPhotoType = data.second_category_id
        this.jewelryType = data.jewelry_type
        this.scenicSpot = data.scenic_spot
          ? data.scenic_spot.map(item => item.id)
          : []

        // 将详情数据交给三步子store格式化
        await Promise.all([
          this.stepOneStore.afterGetDetail(data),
          this.stepTwoStore.afterGetDetail(data),
          this.stepThreeStore.afterGetDetail(data)
        ])

        this.max_step = this.getMaxStep()
        this.oldFormatData = this.getFormatValues()
      })
    }
  }

  /**
   * 获取tag数据
   * 此tag数据，包含第三步中的标签，和婚纱摄影-旅拍目的地-基本信息中的旅拍目的地标签
   */
  getTags = async () => {
    let { success, data } = await Api.getTags({
      property_id: this.property_id,
      second_category_id: this.second_category_id,
      sex:
        this.property_id == 12 && this.gender ? (this.gender == 1 ? 1 : 2) : ''
    })
    if (success) {
      runInAction(() => {
        this.tag_list = data
        if (this.max_step == 3) {
          this.stepThreeStore.tag_list = data.filter(
            item => item.id != 3377 && item.id != 3421
          )
          this.stepThreeStore.initTagList(this.detailData.tags)
        }
      })
    }
  }

  formatStepThree = value => {
    if (!value) {
      return {}
    }
    const tag_list = []
    const list = value.tag_list || []
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].children.length; j++) {
        if (list[i].children[j].isActive) {
          tag_list.push(list[i].children[j].mark_id)
        }
      }
    }
    return { ...value, tag_list: tag_list.join(',') }
  }

  /**
   * 发布/存为草稿
   * @param {string} type draft-草稿  save-发布
   * @param {boolean} noReload 保存完草稿不需要刷新
   */
  handleSave = async (type = 'save', noReload) => {
    runInAction(async () => {
      if (type === 'save') {
        if (!this.isDraft && !this.checkIsValuesChange()) {
          message.info('未修改任何信息，无需提交审核')
          return
        }

        // 校验三步的数据
        if (!this.stepOneStore.validateData()) {
          return
        }
        if (!this.stepTwoStore.validateData()) {
          return
        }
        if (this.max_step === 3 && !this.stepThreeStore.validateStepThree()) {
          return
        }
      }

      this.spinning = true

      // 校验敏感词
      const check = await CheckInputStore.checkAll()
      if (check) {
        message.error('请检验敏感词')
        this.spinning = false
        return
      }
      const checkOtherWord = await this.checkOtherWord()
      if (checkOtherWord) {
        this.spinning = false
        return
      }

      // 图片颜色校验
      const imgChecked = await this.checkImg.beforeAction({
        types: [1, 2, 3]
      })
      if (!imgChecked) {
        this.spinning = false
        return
      }
      // 所有校验通过，开始提交
      await this.submitSetMeal(type, noReload)
    })
  }

  getUrl = () => {
    if (this.isSingle == 1) {
      return '#/localMerchant/singleProduct'
    } else {
      return isStoreAccount()
        ? `${JIA_MENG_GOODS_MANAGE_PATH_A}/${this.property_id}`
        : '#/localMerchant/setMeal'
    }
  }

  /**
   * 数据校验完毕，发布/存为草稿行为
   * @param {string} type draft-草稿  save-发布
   * @param {boolean} noReload 保存完草稿不需要刷新
   */
  submitSetMeal = async (type, noReload) => {
    const param = this.getFormatValues()

    // this.spinning = false
    // return

    let apiInterface
    if (type === 'draft') {
      param.id = this.id
      if (this.isSingle) {
        apiInterface = Api.saveSingleDraft
      } else {
        apiInterface = Api.savePackageDraft
      }
    } else {
      if (this.id && !this.isDraft) {
        // 编辑已发布
        apiInterface = Api.editSetMeal
      } else {
        apiInterface = Api.addSetMeal
        if (this.id) {
          // 发布草稿  把草稿信息传过去
          param.id = ''
          param.draft_type = this.isSingle ? 'sku' : 'work'
          param.draft_id = this.id
        }
      }
    }

    jsonToHump(param)

    const { success, data } = await apiInterface(param)
    if (type === 'save') {
      this.spinning = false
    }
    if (success) {
      this.onSumitSuccess(type, data, noReload)
    } else {
      this.spinning = false
    }
  }

  /** 提交成功后的回调 */
  onSumitSuccess = (type, data, noReload) => {
    this.oldFormatData = this.getFormatValues()
    if (type === 'draft') {
      // 草稿
      message.success('保存成功')
      if (!noReload) {
        setTimeout(() => {
          if (!this.isEdit) {
            let url = this.getUrl() + `/create/${data}?type=draft`
            if (this.isSingle) {
              url += '&isSingle=1'
            }
            if (this.gender) {
              url += `&gender=${this.gender}`
            }
            window.location.href = url
          }
          window.location.reload()
        }, 1000)
      }
    } else {
      // 编辑/发布
      if (this.isEdit && !this.isDraft) {
        // 编辑已发布的套餐
        successModal(this, data)
      } else {
        // 发布新套餐
        successModal(this, data)
      }
    }
  }

  /** 获取格式化后的提交数据 */
  getFormatValues = () => {
    const formattedStepOneData = toJS(this.stepOneStore.formatStepOne())
    const formattedStepTwoData = toJS(this.stepTwoStore.formatStepTwoData())
    const formattedStepThreeData = toJS(this.stepThreeStore.formatStepThree())

    // 第一步和第三步都可能有tag_list 进行拼接
    const tagsOneArr = (formattedStepOneData.tag_list || '')
      .split(',')
      .filter(i => i)
    const tagsThreeArr = (formattedStepThreeData.tag_list || '')
      .split(',')
      .filter(i => i)
    const tag_list = [...tagsOneArr, ...tagsThreeArr].join(',')

    const param = {
      ...formattedStepOneData,
      ...formattedStepTwoData,
      ...formattedStepThreeData,
      tag_list,
      property_id: this.property_id
    }

    return param
  }

  /** 检查数据是否修改 */
  checkIsValuesChange = () => {
    // 如果直接用toJS，深层的Observeble对象不会被转为js，可能导致isEqual不能得到正确结果
    const now = JSON.parse(JSON.stringify(this.getFormatValues()))
    const old = JSON.parse(JSON.stringify(this.oldFormatData))
    return !isEqual(now, old)
  }

  // 删除草稿
  deleteDraft = async () => {
    const api = this.isSingle ? Api.deleteSingleDraft : Api.deletePackageDraft
    const { success } = await api({
      id: this.id
    })
    if (success) {
      message.success('删除成功')
      window.location.href = this.getUrl()
    }
  }

  // 删除已发布
  deleteSubmited = async () => {
    const { success, msg } = await Api.deletePackage({
      id: this.id
    })

    if (success) {
      message.success('删除成功')
      window.location.href = this.getUrl()
    } else {
      Modal.warning({
        title: msg,
        icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
      })
    }
  }

  // 校验一些特殊地方的敏感词
  checkOtherWord = async () => {
    // 校验图文内容
    const sessionPictureData = this.stepTwoStore.stepTwoData.set_meal_detail
    if (sessionPictureData) {
      let sessionPictureTexts = sessionPictureData.reduce((preText, cur) => {
        const content = cur.content || {}
        return preText + content.text || ''
      }, '')
      const { code, keywords } = await CheckInputStore.checkWord(
        sessionPictureTexts
      )
      if (code == 1) {
        return message.error(`图文介绍存在敏感词 ${keywords}，请修改后提交`)
      }
    }

    // 修改行程为了校验最新数据
    if (this.stepTwoStore.stepTwoData.merchandise_params) {
      this.stepTwoStore.stepTwoData.merchandise_params.itinerary_list = this.stepTwoStore.handleFormatItineraryList()
    }
    // 校验服务内容
    const sessionServiceData = toJS(
      this.stepTwoStore.stepTwoData.merchandise_params
    )
    if (sessionServiceData) {
      let sessionServiceStr = ''
      ;(function getObjAllValues(object, cb) {
        for (let key in object) {
          if (object.hasOwnProperty(key)) {
            const element = object[key]
            if (isArray(element) || isObj(element)) {
              getObjAllValues(element)
            } else if (isString(element)) {
              sessionServiceStr += element
            }
          }
        }
      })(sessionServiceData)
      const { code, keywords } = await CheckInputStore.checkWord(
        sessionServiceStr
      )
      if (code == 1) {
        return message.error(`服务内容存在敏感词 ${keywords}，请修改后提交`)
      }
    }
    return false
  }
}
